export default __webpack_public_path__ + "static/media/sanFrancisco49ers@2x.9a227696.jpg";